import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { TYPE_COMPTE_CLIENT } from '@/lib/accountType';

/**
 * Ancienne page « Missions » séparée : elle est remplacée par l'onglet
 * Missions de l'espace client (/mon-compte/missions) et par la page du
 * tableau de bord commerçant (/dashboard/missions). On redirige donc
 * proprement les anciens liens et notifications.
 */
export default function MissionsPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate('/login?redirect=/mon-compte/missions', { replace: true });
      return;
    }
    const isClient = Number(user.typecompte) === TYPE_COMPTE_CLIENT;
    navigate(isClient ? '/mon-compte/missions' : '/dashboard/missions', { replace: true });
  }, [loading, user, navigate]);

  return (
    <div className="min-h-screen bg-background-50 flex items-center justify-center">
      <i className="ri-loader-4-line animate-spin text-2xl text-primary-500"></i>
    </div>
  );
}